import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalComponentBaseProps, useModal } from '@pcmp/react-providers';
import { ModalHeader, Sheets, ModalBody } from '@ingka/modal';
import { useContentTracking } from '@/lib/hooks/tracking';

const ChangelogSider: FC<ModalComponentBaseProps> = ({
  handleDismiss,
  ...rest
}) => {
  // Hooks
  const trackContent = useContentTracking();
  const { t } = useTranslation();
  const { openModal, closeModal } = useModal();

  useEffect(() => {
    trackContent('changelog', { type: 'sider' });
  }, []);

  const goBack = async () => {
    await closeModal(0);
    const { default: HelpCenterSider } = await import('..');

    await openModal({
      component: HelpCenterSider,
      props: {},
    });
  };

  return (
    <Sheets
      {...rest}
      data-testid="changelogModal"
      aria-label={t('label.changelog.description')}
      footer={null}
      header={
        <ModalHeader
          ariaCloseTxt={t('aria.close')}
          title={t('label.changelog.title')}
          backBtnClick={goBack}
        />
      }
    >
      <ModalBody>
        <p>Coming soon...</p>
      </ModalBody>
    </Sheets>
  );
};

export default ChangelogSider;
